// extracted by mini-css-extract-plugin
export default {"list":"_1OyJbt82Jt2eO+WsEae6+A==","title":"_7bl1qcHqRTMBwJizG6BxCg=="};